<template>
  <div class="orderDetail">
    <!-- <div class="head">
        <router-link to="/myOrder">
        <div class="mar-right-10">我的订单</div>
        </router-link>
        <div class='arrow'></div>
        <div class="mar-right-10">订单详情</div>
    </div>-->
    <div class="banxin">
      <div class="statusBar" v-if="orderDetail.state != 5 && orderDetail.state && orderDetail.needConfirm == 1">
        <template v-for="(item, index) in statusArr">
          <div class="status_arrow" :class="`${item.state <= orderDetail.state ? 'active_status' : ''}`" :key="index"
            v-if="index !== 0">
            <a-icon type="right" />
          </div>
          <div class="status_box" :class="`${item.state <= orderDetail.state ? 'active_status' : ''}`" :key="index">
            <div>
              <span>{{ index + 1 }}</span>
              <span>{{ index == 0 && orderDetail.orderFrom == 1 ? "已下单" : item.title }}</span>
            </div>
            <span>{{ item.intro }}</span>
            <i class="active_status_after" v-if="item.state == orderDetail.state && item.state == 1"></i>
          </div>
        </template>
      </div>
      <div class="statusBar" v-if="orderDetail.state != 5 && orderDetail.state && orderDetail.needConfirm == 0">
        <template v-for="(item, index) in statusArr2">
          <div class="status_arrow" :class="`${item.state <= orderDetail.state ? 'active_status' : ''}`" :key="index"
            v-if="index !== 0">
            <a-icon type="right" />
          </div>
          <div class="status_box" :class="`${item.state <= orderDetail.state ? 'active_status' : ''}`" :key="index">
            <div>
              <span>{{ index + 1 }}</span>
              <span>{{ index == 0 && orderDetail.orderFrom == 1 ? "已下单" : item.title }}</span>
            </div>
            <span>{{ item.intro }}</span>
            <i class="active_status_after" v-if="item.state == orderDetail.state && item.state == 1"></i>
          </div>
        </template>
      </div>
      <div class="statusBar" v-if="orderDetail.state == 5 && orderDetail.state">
        <template v-for="(item, index) in statusArr_close">
          <div class="status_arrow" :class="`${item.state <= orderDetail.state ? 'active_status' : ''}`" :key="index"
            v-if="index !== 0">
            <a-icon type="right" />
          </div>
          <div class="status_box" :class="`${item.state <= orderDetail.state ? 'active_status' : ''}`" :key="index">
            <div>
              <span>{{ index + 1 }}</span>
              <span>{{ item.title }}</span>
            </div>
            <span>{{ item.intro }}</span>
            <i class="active_status_after" v-if="item.state == orderDetail.state && item.state == 1"></i>
          </div>
        </template>
      </div>
      <!-- 如果是待付款状态 则展示一个引导信息面板 -->
      <div class="teach-user" v-if="orderDetail.state == 1"
        :style="`${orderDetail.orderFrom == 1 ? 'height:61px;' : ''}`">
        <div class="order-detail-bar" :style="`${orderDetail.orderFrom == 1 ? 'border-bottom:none;' : ''}`">
          <span style="display:none;">{{ orderDetail.paymentMode | paymentModeFormat }}</span>
          <span>当前订单状态:</span>
          <span>{{ orderDetail.orderFrom == 1 ? "已下单" : "已下单" }}</span>
          <!-- <a-icon type="clock-circle" v-if="orderDetail.orderFrom != 1" />
          <div v-if="orderDetail.orderFrom != 1">
            <span v-if="curEndtime.days" class="time-nums">{{curEndtime.days}}</span>
            <span v-if="curEndtime.days">天</span>
            <span v-if="curEndtime.hours" class="time-nums">{{curEndtime.hours}}</span>
            <span v-if="curEndtime.hours">时</span>
            <span v-if="curEndtime.minutes" class="time-nums">{{curEndtime.minutes}}</span>
            <span v-if="curEndtime.minutes">分后, 系统将自动关闭订单</span>
          </div> -->
        </div>
        <div class="order-detail-content" v-if="orderDetail.orderFrom != 1">
          <div>
            <span>1、您需要等待</span>
            <!-- <a-button type="primary" @click="checkPayType">付款</a-button> -->
            <span style="margin: 0 5px;color: #f77b0b;font-size: 14px;font-weight: bold;">卖家确认</span>

          </div>
          <div>
            <span>2、卖家确认后,待账单生成,您可以进行付款(根据卖家设置,部分服务型商品在购买前,需要签署合同)</span>
          </div>
          <div>
            <span>3、如果您不想购买,可以<a-button type="primary" ghost @click="closeOrder">取消订单</a-button></span>
          </div>
        </div>
      </div>
      <!-- 基础信息在这里做一个tab标签页 -->
      <div class="card-container">
        <!-- <a-tabs type="card">
        <a-tab-pane key="1" tab="订单信息">-->
        <div class="order-detail-base">
          <div>
            <p>
              <a-icon type="inbox" />订单信息
            </p>
            <p>订单号: {{ orderDetail.orderFormid }}</p>
            <p>创建时间: {{ orderDetail.createTime }}</p>
            <!-- <p>
              收货地址: {{orderDetail.receiveAdress}}
              <span style="margin-left:6px;">{{orderDetail.address}}</span>
            </p>
            <p>手机: {{orderDetail.receivePhone}}</p>
            <p>电话: 暂无</p> -->
          </div>
          <div>
            <p>
              <a-icon type="shop" />账单信息
            </p>
            <p v-if="orderDetail.state == 1">需等待卖家确认后生成账单</p>
            <template v-else>
              <p>订单总金额: {{ orderDetail.price }}</p>
              <p>已支付金额: {{ orderDetail.priceReceived }}</p>
            </template>

          </div>
          <!-- <div>
            <p>
              <a-icon type="pay-circle" />支付方式
            </p>
            <p>{{orderDetail.paymentMode | paymentModeFormat}}</p>
          </div> -->
          <div style="border:0;">
            <p>
              <a-icon type="shop" />卖家信息
            </p>
            <p>卖家: {{ orderDetail.shopName }}</p>
            <p>店长: {{ orderDetail.chargePersonPhone }}</p>
            <p>收款账号: {{ orderDetail.bankInfo ? orderDetail.bankInfo.bankCard : '暂无' }}</p>
            <!-- <p>手机: {{orderDetail.receivePhone}}</p> -->
            <p>电话：{{ orderDetail.chargePersonPhone }}</p>
          </div>
        </div>
        <!-- </a-tab-pane>
                    <a-tab-pane key="2" tab="物流信息">
                        <div class="logistics" v-if="orderDetail.state===3 || orderDetail.state===4">
                            <p class="fs16 font-color-333">物流信息</p>
                            <div class="content">
                                <div class="left">
                                    <img src="../../../static/image/wuliuxin@2x.png" alt="">
                                    <div>
                                        <p>发货方式：快递</p>
                                        <p>物流公司：{{orderDetail.express}}</p>
                                        <p>运单号码：{{orderDetail.deliverFormid}}</p>
                                    </div>
                                </div>
                                <div class="right">
                                    <div class="title">物流跟踪：</div>
        <div class="dilevery">-->
        <!-- <div v-for="(item, index) in dilevery" :key="index" :class="index==0?'active':''">
                                            <span class="dot">
                                                <span class="line"></span>
                                            </span>
                                            <p>{{item.time}}&emsp;{{item.reason}}</p>
        </div>-->
        <!-- <el-steps direction="vertical" :active="1" space="100">
                                            <el-step :title="item.time+'：'+item.reason" v-for="(item, index) in dilevery" :key="index"></el-step>
                                        </el-steps>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="emptyBox" v-else>
                            暂无物流信息哟~
                        </div>
                    </a-tab-pane>
                    <a-tab-pane key="3" tab="交易方式">
                        <div class="emptyBox">
                            {{orderDetail.paymentMode | paymentModeFormat}}
                        </div>
                    </a-tab-pane>
        </a-tabs>-->
      </div>
      <div
        style="font-size: 18px;font-weight: bold;padding: 15px 0px;display:flex;align-items:center;margin-bottom:0px;">
        <i style="display:inline-block;width: 3px;height: 18px;background: #F77B0B;margin-right:10px;"></i>商品信息
      </div>
      <div class="product-container">
        <div v-if="false" class="productInfo">
          <div class="top">
            <span class="big">商品</span>
            <span>商品属性</span>
            <span>状态</span>
            <span>数量</span>
            <span>单价</span>
          </div>
          <div class="bottom" v-for="(pro, idx) in orderDetail.skus" :key="idx"
            @click="toProductDetail(orderDetail.shopId, pro)">
            <div class="big">
              <img :src="pro.image" alt />
              <p>{{ pro.productName }}</p>
            </div>
            <div style="flex-direction: column;">
              <p v-for="(text, ins) in pro.values" :key="ins">{{ text }}</p>
            </div>
            <div v-if="orderDetail.state == 1">待付款</div>
            <div v-if="orderDetail.state == 2">待发货</div>
            <div v-if="orderDetail.state == 3">待收货</div>
            <div v-if="orderDetail.state == 4">已完成</div>
            <div v-if="orderDetail.state == 5">已关闭</div>
            <div v-if="orderDetail.state == 6">待成团</div>
            <div style="flex-direction: column;">
              <span>x {{ pro.checkNumber }}</span>
              <del style="font-size: 12px;color: #999;">x {{ pro.number }}</del>
            </div>
            <!-- -->
            <div v-if="pro.originalPrice == 0" class="font-color-FF7 fs-bold">¥{{ pro.price }}</div>
            <div v-else class="price">
              <span>¥{{ pro.price }}</span><del style="color:#999;"
                v-if="pro.originalPrice && pro.originalPrice != pro.price">¥{{ pro.originalPrice }}</del>
            </div>
          </div>
        </div>
        <div>
          <div style="display: flex;background: #cccccc4f;padding: 10px;">
            <span :style="`width:${orderDetail.timeSkuStatus ? '40' : '30'}%;padding-left:20px;`">商品信息</span>
            <span :style="`width:${orderDetail.timeSkuStatus ? '10' : '30'}%;text-align:center;`">{{
                orderDetail.timeSkuStatus ? `单价(元/${orderDetail.timeSkuName})` : '单价(元)'
            }}</span>
            <span :style="`width:${orderDetail.timeSkuStatus ? '10' : '30'}%;text-align:center;`">数量</span>
            <span v-if="orderDetail.timeSkuStatus" style="width:20%;text-align:center;">租赁时间(单位/{{
                orderDetail.timeSkuName
            }})</span>
            <span :style="`width:${orderDetail.timeSkuStatus ? '20' : '30'}%;text-align:center;`">金额(元)</span>
          </div>
          <div v-for="(item, index) in orderDetail.skus" :key="index"
            style="display:flex;align-items:center;padding:20px 10px;border: 1px solid #E5E5E5FF;border-top: none;">
            <span :style="`width:${orderDetail.timeSkuStatus ? '40' : '30'}%;display:flex;align-items:stretch;`">
              <div style="width: 100px;height: 100px;overflow: hidden;">
                <img :src="item.image" height="100%" alt="" srcset="">
              </div>
              <div
                style="display: flex;flex-direction: column;justify-content: space-between;box-sizing: border-box;padding: 10px 10px;width: calc(100% - 100px);">
                <div style="font-size:14px;font-weight:bold;">{{ item.productName }}</div>
                <div style="font-size: 13px;color: #767676;">
                  <div>{{ item.values.join('/') }}</div>
                  <div v-for="(ets, index) in item.exSku" :key="index">
                    <div>{{ `${ets.name}:
                                          ${ets.value}(价格:${ets.price}元)`
                    }}</div>
                  </div>

                </div>
              </div>
            </span>
            <span :style="`width:${orderDetail.timeSkuStatus ? '10' : '30'}%;text-align:center;`">
              {{ item.price }}
            </span>
            <span :style="`width:${orderDetail.timeSkuStatus ? '10' : '30'}%;text-align:center;`">
              x{{ item.number }}
            </span>
            <span v-if="orderDetail.timeSkuStatus" style="width:20%;text-align:center;">
              <div>起始日期:{{ item.timeSkuStart }}</div>
              <div>结束日期:{{ item.timeSkuEnd }}</div>
              <div>总计:{{ item.timeSkuNumber }}{{ item.timeSkuName }}</div>
            </span>
            <span :style="`width:${orderDetail.timeSkuStatus ? '20' : '30'}%;text-align:center;`">
              {{ item.total }}
            </span>
          </div>
          <div v-if="orderDetail.skus.length == 0"
            style="display: flex;align-items: center;justify-content: center;height: 200px;margin-bottom: -10px;font-size: 20px;color: #939393;">
            您暂未选择商品哦
          </div>
        </div>
      </div>
      <div class="settlement-container">
        <div class="settlement">
          <div class="box">
            <div class="left">
              <p v-if="orderDetail.originalPrice != 0">
                商品总价：
                <del class="right" style="color:#d3d3d3 !important;">¥{{ orderDetail.originalPrice }}</del>
              </p>
              <p v-else>
                商品总价：
                <del class="right" style="color:#d3d3d3 !important;">¥{{ orderDetail.orderPrice }}</del>
              </p>
              <!-- <p>
                运费：
                <span class="right">¥{{orderDetail.logisticsPrice}}</span>
              </p> -->
              <p>
                平台优惠：
                <span class="right">-¥{{ orderDetail.discountPrice }}</span>
              </p>
              <div v-if="orderDetail.paymentState == 0" class="mar-top-20">
                需付款：
                <span class="right" style="color:#FF7800;">¥{{ orderDetail.price }}</span>
                <!-- <div v-if="orderDetail.originalPrice !=0" class="right"
                  style="display:block;text-decoration:line-through;color:#999!important;">
                  ¥{{orderDetail.originalPrice}}</div> -->
              </div>
              <div v-if="orderDetail.paymentState == 1 && !isSchool" class="mar-top-20">
                实付款：
                <span class="right" style="color:#FF7800;">¥{{ orderDetail.price }}</span>
                <div v-if="orderDetail.originalPrice != 0" class="right"
                  style="display:block;text-decoration:line-through;color:#999!important;">
                  ¥{{ orderDetail.originalPrice }}</div>
              </div>
              <div v-if="orderDetail.paymentState == 1 && isSchool" class="mar-top-20">
                实际需付款：
                <span class="right" style="color:#FF7800;">¥{{ orderDetail.checkPrice -
                    orderDetail.discountPrice
                }}</span>
                <p class="fs13 mar-bot-5" style="color:#999;display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 4px;">首次支付金额: ¥{{ (orderDetail.orderPrice - orderDetail.discountPrice).toFixed(2) }}</p>
                <p style="color:#999;display: flex;
    align-items: center;
    justify-content: flex-end;" class="fs13 mar-bot-5"
                  v-if="orderDetail.checkPrice - orderDetail.orderPrice > 0 && orderDetail.state == 4">已追加支付金额: <span
                    style="color:#ff4747">¥{{ (orderDetail.checkPrice - orderDetail.orderPrice).toFixed(2) }}</span></p>
                <p style="color:#999;display: flex;
    align-items: center;
    justify-content: flex-end;" class="fs13 mar-bot-5"
                  v-if="orderDetail.checkPrice - orderDetail.orderPrice < 0 && orderDetail.state == 4">已退款金额: <span
                    style="color:#ff4747">¥{{ (orderDetail.orderPrice - orderDetail.checkPrice).toFixed(2) }}</span></p>
                <p v-if="orderDetail.originalPrice != 0" class="fs13 mar-bot-5" style="text-decoration:line-through;color:#999;display: flex;
    align-items: center;
    justify-content: flex-end;padding-right: 4px;">原价: ¥{{ (orderDetail.originalPrice -
        orderDetail.discountPrice).toFixed(2)
    }}</p>
                <p class="fs13" style="display: flex;
    align-items: center;
    justify-content: flex-end;padding-right: 4px;">(含运费：¥{{ orderDetail.logisticsPrice }})</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="remark-box">
        <span style="color:#999;">订单备注: </span> {{ orderDetail.remark || '暂无备注' }}
      </div>
      <!-- 老版 -->
      <!-- <div class="status">
              <div class="left">
      <p class="fs16 fw-blod mar-top-20 mar-bot-60">订单号：{{orderDetail.orderFormid}}</p>-->
      <!-- <div class="groupShopping">
                  <div class="groupShopTit">等待成团</div>
                  <span @click="inviteFriends">邀请好友</span>
                  <span class="closeOrder" @click="closeOrder">取消订单</span>
      </div>-->
      <!-- <div class="box" v-if="orderDetail.state==1">
                     <p class="fs24 fw-blod mar-bot-10 font-color-71B">等待付款</p>
                     <p v-if="orderDetail.collageId==0" class="time fs12 mar-bot-10 font-color-999 flex-items"><img style="width:13px;height:13px;margin-right:5px;" src="../../../static/image/alarm_clock@2x.png" alt=""> 剩余时间{{endTime | formatMinutes}}</p>
                     <p v-else class="time fs12 mar-bot-10 font-color-999 flex-items"><img style="width:13px;height:13px;margin-right:5px;" src="../../../static/image/alarm_clock@2x.png" alt=""> 剩余时间{{endTime1 | formatMinutes}}</p>
                     <el-button plain size="small" @click="closeOrder" class="cancel mar-bot-10">取消订单</el-button>
                     <el-button plain size="small" @click="getUrl" class="pay mar-bot-10">付款</el-button>
                </div>
                <div class="box" v-if="orderDetail.state==6 || orderDetail.collageId!=0 && orderDetail.paymentState==1 || orderDetail.collageId!=0 && orderDetail.state==5">
                     <p class="fs24 fw-blod mar-bot-10 font-color-FF7" v-if="orderDetail.paymentState==1 && groupData.state==0">等待成团</p>
                     <p class="fs24 fw-blod mar-bot-10 font-color-FF7" v-if="orderDetail.paymentState==1 && groupData.state==1">拼团成功</p>
                     <p class="fs24 fw-blod mar-bot-10 font-color-red" v-if="orderDetail.state==5 && groupData.state==2">拼团失败</p>
                     <el-button plain size="small" @click="inviteFriends" class="invite mar-bot-10" v-if="orderDetail.paymentState==1 && groupData.state==0">邀请好友</el-button>
                     <el-button plain size="small" @click="closeOrder" class="cancel mar-bot-10" v-if="groupData.state==0">取消订单</el-button>
                     <el-button plain size="small" @click="again" class="invite" v-if="groupData.state!=0">再次开团</el-button>
                </div>
                 <div class="box mar-top-40" v-if="orderDetail.state==2 && orderDetail.collageId==0">
                     <p class="fs24 fw-blod font-color-FF7">待发货</p>
                 </div>
                 <div class="box mar-top-40" v-if="orderDetail.state==3 && orderDetail.collageId==0">
                     <p class="fs24 fw-blod mar-bot-10 font-color-FF7">运输中</p>
                 </div>
                 <div class="box mar-top-40" v-if="orderDetail.state==4 && orderDetail.collageId==0">
                     <p class="fs24 fw-blod mar-bot-10 font-color-71B">已完成</p>
                 </div>
                 <div class="box mar-top-40" v-if="orderDetail.state==5 && orderDetail.collageId==0">
                     <p class="fs24 fw-blod mar-bot-10 font-color-71B">已关闭</p>
      </div>-->
      <!-- <div v-if="orderDetail.state==6">
                     <p class="fs24 fw-blod mar-bot-10 font-color-FF7">申请退货</p>
                 </div>
                 <div v-if="orderDetail.state==7">
                     <p class="fs24 fw-blod mar-bot-10 font-color-FF7">处理中</p>
                 </div>
                 <div v-if="orderDetail.state==6">
                     <p class="fs24 fw-blod mar-bot-10 font-color-71B">已取消</p>
                 </div>
                 <div v-if="orderDetail.state==8">
                     <p class="fs24 fw-blod mar-bot-10 font-color-71B">已退款</p>
      </div>-->
      <!-- </div>
              <div class="right">
                  <StatusOne :createTime="orderDetail.createTime" v-if="orderDetail.state==1 && orderDetail.collageId==0"></StatusOne>
                  <StatusTwo :createTime="orderDetail.createTime" v-if="orderDetail.state==2 && orderDetail.collageId==0"></StatusTwo>
                  <StatusThree :createTime="orderDetail.createTime" v-if="orderDetail.state==3 && orderDetail.collageId==0"></StatusThree>
                  <StatusFour :receiveTime="orderDetail.receiveTime" :createTime="orderDetail.createTime" v-if="orderDetail.state==4 && orderDetail.collageId==0"></StatusFour>
                  <StatusFive :createTime="orderDetail.createTime" v-if="orderDetail.state==5 && orderDetail.collageId==0"></StatusFive>
                  <StatusSix :type="6" :createTime="orderDetail.createTime" v-if="orderDetail.state==6 && orderDetail.collageId!=0"></StatusSix>
                  <StatusSix :type="1" :createTime="orderDetail.createTime" v-if="orderDetail.state==1 && orderDetail.collageId!=0"></StatusSix>
                  <StatusSix :type="2" :createTime="orderDetail.createTime" v-if="orderDetail.state==2 && orderDetail.collageId!=0"></StatusSix>
                  <StatusSix :type="3" :createTime="orderDetail.createTime" v-if="orderDetail.state==3 && orderDetail.collageId!=0"></StatusSix>
                  <StatusSix :receiveTime="orderDetail.receiveTime" :type="4" :createTime="orderDetail.createTime" v-if="orderDetail.state==4 && orderDetail.collageId!=0"></StatusSix>
                  <StatusSix :type="5" :createTime="orderDetail.createTime" v-if="orderDetail.state==5 && orderDetail.collageId!=0"></StatusSix>
              </div>
      </div>-->
      <!--          拼单信息-->
      <!-- <div class="groupBuying" v-if="orderDetail.collageId!=0 && orderDetail.state!=1">
            <div class="groupBuyTit">拼团信息</div>
            <div class="groupBuyBox">
              <div class="result" v-if="groupData.state==0">付款成功，待成团</div>
              <div class="result" v-if="groupData.state==1">恭喜您拼团成功</div>
              <div class="result0 mar-bot-20 fs18" v-if="groupData.state==2">未能按时成团，拼团失败</div>
              <p v-if="groupData.state==0">{{ groupData.person }}人团，离拼团成功还差<span>{{ groupData.people }}</span>人</p>
              <div class="surplusTime" v-if="groupData.state==0">剩余时间：<span class="day time">{{groupData.time | formatHours}}</span>时<span class="time">{{groupData.time | formatMinutes}}</span>分<span class="time">{{groupData.time | formatSeconds}}</span>秒</div>
              <div class="userList">
                <span v-for="(item,index) of groupData.personList" :key="item.id">
                  <i v-if="index === 0">团长</i>
                  <img :src="item.headImage" alt="">
                </span>
                <span class="noPeople iconfont" v-for="index of groupData.people" :key="index + 'n'">
                  &#xe64b;
                </span>
              </div>
            </div>
      </div>-->
      <!-- <div class="logistics" v-if="orderDetail.state===3 || orderDetail.state===4">
              <p class="fs16 font-color-333">物流信息</p>
              <div class="content">
                  <div class="left">
                      <img src="../../../static/image/wuliuxin@2x.png" alt="">
                      <div>
                          <p>发货方式：快递</p>
                          <p>物流公司：{{orderDetail.express}}</p>
                          <p>运单号码：{{orderDetail.deliverFormid}}</p>
                      </div>
                  </div>
                  <div class="right">
                      <div class="title">物流跟踪：</div>
      <div class="dilevery">-->
      <!-- <div v-for="(item, index) in dilevery" :key="index" :class="index==0?'active':''">
                              <span class="dot">
                                  <span class="line"></span>
                              </span>
                              <p>{{item.time}}&emsp;{{item.reason}}</p>
      </div>-->
      <!-- <el-steps direction="vertical" :active="1" space="100">
                            <el-step :title="item.time+'：'+item.reason" v-for="(item, index) in dilevery" :key="index"></el-step>
                          </el-steps>
                      </div>
                  </div>
              </div>
      </div>-->
      <!-- <div class="desc">
              <div class="receivingInfo">
                  <p class="title">收货信息</p>
                  <div class="info">
                      <p>收货地址：{{orderDetail.receiveAdress}}{{orderDetail.address}}</p>
                      <p>收货人：{{orderDetail.receiveName}}</p>
                      <p>收货电话：{{orderDetail.receivePhone}}</p>
                  </div>
              </div>
              <div class="storeInfo">
                  <p class="title">卖家信息</p>
                  <div class="info">
                      <p>店铺名称：{{orderDetail.shopName}}</p>
                      <p>联系电话：{{orderDetail.chargePersonPhone}}</p>
                  </div>
              </div>
              <div class="orderInfo">
                  <p class="title">订单信息</p>
                  <div class="info">
                      <p>订单号：{{orderDetail.orderFormid}}</p>
                      <p v-if="orderDetail.paymentState==1">支付渠道：{{orderDetail.paymentMode}}</p>
                      <p v-if="orderDetail.paymentState==1">交易号：{{orderDetail.transactionId}}</p>
                      <p>创建时间：{{orderDetail.createTime}}</p>
                      <p v-if="orderDetail.paymentState==1">付款时间：{{orderDetail.paymentTime}}</p>
                      <p v-if="orderDetail.state==4">成交时间：{{orderDetail.receiveTime}}</p>
                      <p>备注：{{orderDetail.remark}}</p>
                  </div>
              </div>
              <div class="productInfo">
                  <div class="top">
                      <span class="big">商品</span>
                      <span>商品属性</span>
                      <span>状态</span>
                      <span>数量</span>
                      <span>单价</span>
                  </div>
                  <div class="bottom" v-for="(pro, idx) in orderDetail.skus" :key="idx">
                      <div class="big">
                          <img :src="pro.image" alt="">
                          <p>{{pro.productName}}</p>
                      </div>
                      <div style="flex-direction: column;">
                          <p v-for="(text, ins) in pro.values" :key="ins">{{text}}</p>
                      </div>
                      <div v-if="orderDetail.state==1">待付款</div>
                      <div v-if="orderDetail.state==2">待发货</div>
                      <div v-if="orderDetail.state==3">待收货</div>
                      <div v-if="orderDetail.state==4">已完成</div>
                      <div v-if="orderDetail.state==5">已关闭</div>
                      <div v-if="orderDetail.state==6">待成团</div>
                      <div>{{pro.number}}</div>
                      <div class="font-color-FF7 fs-bold">¥{{pro.price}}</div>
                  </div>
              </div>
              <div class="settlement">
                  <div class="box">
                      <div class="left">
                          <p>商品总价：<span class="right" style="color:#FF7800;">¥{{orderDetail.orderPrice }}</span></p>
                          <p>运费：<span class="right">¥{{orderDetail.logisticsPrice}}</span></p>
                          <p>平台优惠：<span class="right">-¥{{orderDetail.discountPrice}}</span></p>
                          <p v-if="orderDetail.paymentState==0" class="mar-top-20">需付款：<span class="right mar-top-20" style="color:#FF7800;">¥{{orderDetail.price}}</span></p>
                          <p v-if="orderDetail.paymentState==1" class="mar-top-20">实付款：<span class="right" style="color:#FF7800;">¥{{orderDetail.price}}</span></p>
                      </div>
                  </div>
              </div>
      </div>-->
    </div>
    <div class="banxin" v-if="orderDetail.state != 1">
      <div style="font-size: 18px;font-weight: bold;padding: 15px 0px;display:flex;align-items:center;"><i
          style="display:inline-block;width: 3px;height: 18px;background: #F77B0B;margin-right:10px;"></i>账单信息</div>
      <div style="display:flex;align-items:baseline;margin-bottom:15px;">
        <span style="font-size: 16px;font-weight: bold;margin-right:5px;">订单总金额:</span>
        <span style="font-size: 22px;font-weight: bold;margin-right:20px;">¥{{ (orderDetail.price).toFixed(2) }}</span>
        <span style="font-size: 16px;font-weight: bold;margin-right:5px;">已出账金额:</span>
        <span style="font-size: 22px;font-weight: bold;">¥{{ orderDetail.billList.map(el =>
            el.billAmount).reduce((total, cur) => (total + cur)).toFixed(2)
        }}</span>
      </div>
      <div>
        <div style="display: flex;background: #cccccc4f;padding: 10px;">
          <span style="width:5%;text-align:center;">
            <el-checkbox v-model="orderDetail.allchecked" @change="allClick($event, orderDetail)"></el-checkbox>
          </span>
          <span style="width:15%;text-align:center;">账单号</span>
          <span style="width:10%;text-align:center;">账单金额(元)</span>
          <span style="width:10%;text-align:center;">账单状态</span>
          <span style="width:10%;text-align:center;">截止时间</span>
          <span style="width:10%;text-align:center;">备注</span>
          <span style="width:15%;text-align:center;">订单号</span>
          <span style="width:15%;text-align:center;">创建时间</span>
          <span style="width:10%;text-align:center;margin-left:auto;">更新时间</span>
        </div>
        <div v-for="(item, index) in orderDetail.billList" :key="index"
          style="display:flex;align-items:center;padding:20px 10px;border: 1px solid #E5E5E5FF;border-top: none;">
          <span style="width:5%;text-align:center;">
            <el-checkbox v-model="item.checked" @change="itemClick($event, orderDetail, item)"
              :disabled="item.billStatus == 1 ? true : false"></el-checkbox>
          </span>
          <span style="width:15%;text-align:center;">
            {{ item.billFormid }}
          </span>
          <span style="width:10%;text-align:center;">
            {{ item.billAmount }}
          </span>
          <span style="width:10%;text-align:center;">
            <span v-if="item.billStatus == 0" style="color:#F77B0BFF;">待支付</span>
            <span v-if="item.billStatus == 1" style="color:#00AA5BFF;">已支付</span>
            <span v-if="item.billStatus == 2" style="color:#FF4747FF;">已逾期</span>
          </span>
          <span style="width:10%;text-align:center;">
            {{ item.billEx }}
          </span>
          <span style="width:10%;text-align:center;">
            {{ item.remark }}
          </span>
          <span style="width:15%;text-align:center;">
            {{ item.orderFormid }}
          </span>
          <span style="width:15%;text-align:center;">
            {{ item.createTime }}
          </span>
          <span style="width:10%;text-align:center;margin-left:auto;">
            {{ item.updateTime }}
          </span>
        </div>
      </div>
      <div v-if="orderDetail.payCount != orderDetail.billList.length"
        style="display:flex;justify-content:flex-end;align-items:center;margin:10px 0;">
        <el-button :loading="payLoad" type="primary" @click="confirmPay(orderDetail)">立即支付</el-button>
      </div>

    </div>
    <el-dialog title="提示" :visible.sync="closeOrderDialog" width="30%" :before-close="closeOrderBtn">
      <span>是否取消该订单?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeOrderDialog = false">取 消</el-button>
        <el-button type="primary" @click="cancelOrder">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="inviteDialog" width="30%" :before-close="inviteDialogClose">
      <div class="inviteDialog">
        <div class="inviteTit">邀请好友</div>
        <div class="imgCode">
          <img :src="share.qrcode" alt />
        </div>
        <!-- <p>扫描下方二维码或复制链接分享给好友吧</p>
        <div class="linkBox">
          <span class="linkAddress">www.1234567.com</span>
          <span class="copyBtn">复制</span>
        </div>-->
      </div>
    </el-dialog>
    <el-dialog class="weChat" :visible.sync="weChatDialog" :before-close="handleClose" width="25%">
      <div class="weChatBox" style="">
        <div style="font-size:18px;color:#000000;padding:0 20px;">
          请使用具有扫码支付功能的APP完成支付（支持微信、支付宝、云闪付等APP）
        </div>
        <div style="font-size:32px;color:#000000;width:100%;text-align:center;">￥{{ payInfo.money }}</div>
        <div class="qCode">
          <img :src="`data:image/jpeg;base64,${payInfo.c2bQrCodeBase64}`" width="100%" height="100%" alt />
          <!-- <img src="../../assets/images/weiXintit.png" alt=""> -->
        </div>
        <!-- <div class="weChatInfo">
            <img src="../../assets/images/imgPay.png" alt="">
        </div>-->
      </div>
    </el-dialog>
    <a-modal v-model="showTeachDialog" :title="false" :maskClosable="false" :footer="false" :width="950">
      <div class="offlinePayBox">
        <div class="offlinePayBox-title">
          <span>操作步骤</span>
          <div>
            <span>请在</span>
            <span v-if="curEndtime.days" class="time-nums">{{ curEndtime.days }}</span>
            <span v-if="curEndtime.days">天</span>
            <span v-if="curEndtime.hours" class="time-nums">{{ curEndtime.hours }}</span>
            <span v-if="curEndtime.hours">时</span>
            <span v-if="curEndtime.minutes" class="time-nums">{{ curEndtime.minutes }}</span>
            <span v-if="curEndtime.minutes">分 内完成支付</span>
          </div>
        </div>
        <div class="offlinePayBox-process-bar">
          <span>1</span>
          <div>
            <span>打开手机银行APP/PC网银,或者前往银行柜台</span>
          </div>
        </div>
        <div class="offlinePayBox-process-bar">
          <span>2</span>
          <div>
            <span>
              用您的银行卡向以下账户进行转账，并备注填写
              <b style="color:#FF4747">付款验证码</b>
            </span>
          </div>
        </div>
        <!-- <div class="offlinePayBox-process-bar-small"><span>并备注填写付款验证码</span></div> -->
        <div class="offlinePayBox-main-box">
          <div class="offlinePayBox-main-box-title">收款账户信息</div>
          <div>
            <span>收款户名</span>
            <span id="offlinePayBox-bar1">{{ orderDetail.bankInfo.collectionNme }}</span>
            <span @click="copyText(orderDetail.bankInfo.collectionNme)">复制</span>
          </div>
          <div>
            <span>收款账号</span>
            <span id="offlinePayBox-bar2">{{ orderDetail.bankInfo.bankCard }}</span>
            <span @click="copyText(orderDetail.bankInfo.bankCard)">复制</span>
          </div>
          <div>
            <span>收款银行</span>
            <span id="offlinePayBox-bar3">{{ orderDetail.bankInfo.bankName }}</span>
            <span @click="copyText(orderDetail.bankInfo.bankName)">复制</span>
          </div>
          <div>
            <span>所在地</span>
            <span id="offlinePayBox-bar4">{{ orderDetail.bankInfo.location }}</span>
          </div>
          <div>
            <span>付款验证码</span>
            <span id="offlinePayBox-bar5">{{ orderDetail.transferCode }}</span>
            <span @click="copyText(orderDetail.transferCode)">复制</span>
          </div>
        </div>
        <div class="offlinePayBox-process-bar">
          <span>3</span>
          <div>
            <span>系统根据所填写的付款验证码，自动识别到来账，自动核销订单</span>
          </div>
        </div>
        <div class="offlinePayBox-process-bar-small">
          <span>（工作时间同行转账预计2小时，跨行转账T+3天；非工作日均可能有延迟）</span>
        </div>
        <div class="offlinePayBox-process-bar-small" style="color:#FF4747;margin-top:5px;">
          <span>*请仔细核对以上信息，请勿填写错误</span>
        </div>
        <div class="offlinePayBox-small-info">
          <div class="offlinePayBox-small-info-title">
            <span>*</span>
            <span>注意事项</span>
          </div>
          <div class="offlinePayBox-small-info-bar">
            <span>付款验证码：转账时付款验证码需填写在转账备注里且不得有误，请仔细检查</span>
          </div>
          <div class="offlinePayBox-small-info-bar">
            <span>转账金额与订单金额务必保持一致</span>，不得多转，不得少转，不得分次转账;
          </div>
          <div class="offlinePayBox-small-info-bar">转账的到账时间：建议转账半小时后查看到账情况，工作时间同行转账预计2小时，跨行转账T+3天；非工作日均可能有延迟，以付款方银行规则为准；
          </div>
          <div class="offlinePayBox-small-info-bar">
            在转账页面若找不到收款银行，可搜索“民营银行”，再选择
            <span>“富滇银行”</span>
          </div>
          <div class="offlinePayBox-small-info-bar">
            转账成功后到已买到的货品页面查询订单状态，
            <span>订单状态则为付款成功，等待发货。</span>
          </div>
          <div class="offlinePayBox-small-info-bar">如有其他问题,可联系平台客服咨询,咨询热线400-8816-132</div>
          <div class="offlinePayBox-small-info-title" style="margin-top:28px;margin-bottom:10px;">银行资金流向</div>
          <img src="@/assets/images/money-line.png" alt srcset />
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import StatusOne from "../../components/status/statusOne";
import StatusTwo from "../../components/status/statusTwo";
import StatusThree from "../../components/status/statusThree";
import StatusFour from "../../components/status/statusFour";
import StatusFive from "../../components/status/statusFive";
import StatusSix from "../../components/status/statusSix";
import api from "../../api_serv";
import { listSearchMixin } from "../../config/mixin";
import { mapGetters, mapMutations } from "vuex";
import moment from "moment";
import * as clipboard from "clipboard-polyfill/text";
export default {
  mixins: [listSearchMixin],
  components: {
    StatusOne,
    StatusTwo,
    StatusThree,
    StatusFour,
    StatusFive,
    StatusSix
  },
  data() {
    return {
      isSchool: localStorage.getItem('isSchool') == 'true',
      statusArr: [
        { title: "已下单", state: 1, intro: "" },
        { title: "待付款", state: 2, intro: "" },
        { title: "待核销", state: 3, intro: "" },
        { title: "已完成", state: 4, intro: "" }
      ],
      statusArr2: [
        { title: "已下单", state: 1, intro: "" },
        { title: "待付款", state: 2, intro: "" },
        // { title: "待核销", state: 3, intro: "" },
        { title: "已完成", state: 4, intro: "" }
      ],
      statusArr_close: [
        { title: "已下单", state: 1, intro: "" },
        { title: "已关闭", state: 5, intro: "" }
      ],
      orderDetail: {},
      value: "",
      values: "",
      textarea: "",
      textarea1: "",
      text: "",
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      orderId: null,
      parentId: null,
      dilevery: [],
      endTime: "",
      closeOrderDialog: false,
      inviteDialog: false,
      share: {},
      groupData: {},
      setTime: null,
      endTime1: "",
      noticeId: "",
      weChatDialog: false,
      payInfo: {},
      chatTimer: null,
      showTeachDialog: false,
      payLoad: false
    };
  },
  filters: {
    formatHours: function (value) {
      let hours = Math.floor(value / (1000 * 60 * 60));
      if (hours < 10) {
        return "0" + hours;
      } else {
        return hours;
      }
    },
    formatMinutes: function (value) {
      let $moment = moment.duration(value, "milliseconds");

      // 案例：时分秒 00:00:00
      let str = [
        $moment.days(),
        $moment.hours(),
        $moment.minutes(),
        $moment.seconds()
      ].join(":");

      str = `${$moment.days() ? `${$moment.days()}天` : ""}${$moment.hours() ? `${$moment.hours()}时` : ""
        }${$moment.minutes() ? `${$moment.minutes()}分` : ""}`;

      return str;
      // let minutes = Math.floor((value % (1000 * 60 * 60)) / (1000 * 60))
      // if (minutes < 10) {
      //   return '0' + minutes
      // } else {
      //   return minutes
      // }
    },
    formatSeconds: function (value) {
      let seconds = Math.round((value % (1000 * 60)) / 1000);
      if (seconds < 10) {
        return "0" + seconds;
      } else {
        return seconds;
      }
    }
  },
  created() {
    this.orderId = this.$route.query.orderId;
    this.parentId = this.$route.query.parentId;
    if (this.$route.query.noticeId) {
      this.noticeId = this.$route.query.noticeId;
    }
    if (this.$route.query.showProcess) {
      this.showTeachDialog = true;
    }
  },
  mounted() {
    this.getOrderDetail();

  },
  destroyed() {
    clearInterval(this.setTime);
  },

  computed: {
    ...mapGetters([
      "userInfo", // 用户信息
    ]),
    curEndtime(state) {
      if (state.endTime) {
        let $moment = moment.duration(state.endTime, "milliseconds");
        return {
          days: $moment.days(),
          hours: $moment.hours(),
          minutes: $moment.minutes(),
          seconds: $moment.seconds()
        };
      }
      return {};
    }
  },
  methods: {
    ...mapMutations({
      setUserInfo: "SET_USERINFO"
    }),
    allClick(e, item) {
      console.log(e)
      for (let j = 0; j < item.billList.length; j++) {

        if (e) {
          item.billList[j].checked = true
        } else {
          item.billList[j].checked = false
        }
      }
      this.$forceUpdate();
      console.log(this.orderDetail)
    },
    itemClick(e, item, item2) {

      console.log(e)

      let count = 0
      for (let j = 0; j < item.billList.length; j++) {
        if (item.billList[j].checked == true) {
          count++
        }
      }
      if (count == item.billList.length) {
        item.allchecked = true
      }
      for (let l = 0; l < item.billList.length; l++) {
        if (item2.billId == item.billList[l].billId) {
          item.billList[l] = item2
          if (e) {
            item.billList[l].checked = true
          } else {
            item.billList[l].checked = false
            item.allchecked = false
          }
        }
      }
      this.$forceUpdate();
      console.log(this.orderDetail)
    },
    //立即支付
    confirmPay(item) {
      //billPay
      let self = this;
      console.log(item)
      let billIds = []
      for (let j = 0; j < item.billList.length; j++) {
        if (item.billList[j].checked == true) {
          item.billList[j].checked = true
          billIds.push(item.billList[j].billId)
        }
      }
      console.log(billIds.join(","))
      if (billIds.length == 0) {
        self.$message({
          message: "请选择要支付的账单",
          type: "warning",
        });
        return
      }
      this.payLoad = true
      // this.$router.push({
      //   path: "../confirmPay_serv",
      //   query: {
      //     billInfo: item,
      //   },
      // });

      let params = {
        url: api.getUserInfo,
        method: "post",
        data: {
          buyerUserId: this.userInfo.buyerUserId,
        },
      };
      self.sendReq(params, (res) => {

        if (res.code === "200") {
          self.setUserInfo(res.data);
          console.log(this.userInfo)
          let params2 = {
            url: api.billPay,
            method: "post",
            data: {
              billIds: billIds.join(","),
              ip: '',
              orderId: item.orderId,
              user: res.data
            },
          };
          self.sendReq(params2, (res2) => {

            if (res2.code === "200") {
              console.log(res2)
              if (res2.data && res2.data.payUrl) {
                this.payLoad = false
                self.$message({
                  message: '即将跳转工行支付界面...',
                  type: "success",
                });
                setTimeout(() => {
                  var a = document.createElement('a');
                  a.setAttribute('href', res2.data.payUrl.url);
                  a.setAttribute('target', '_blank');
                  a.setAttribute('id', "toPay");
                  // 防止反复添加
                  if (!document.getElementById("toPay")) document.body.appendChild(a);
                  a.click();
                  // let url = "https://cpay3.dccnet.com.cn/corporpay/servlet/ICBCCPayBusinessServlet?unique_serialno=2022110211261470900000000002820013&signstr=88DCA78EF441521B4E49DEC55DF1E03C74A14D2EE84EFE210CAFA25F913E8B13D5CEBBF7FCE625D2"
                  // window.open("_blank")
                  // window.location.href = res.data.url

                }, 2000);
              }

            } else {
              this.payLoad = false
              self.$message({
                message: res2.errorData || res2.message,
                type: "warning",
              });
            }
          });
        } else {
          this.payLoad = false
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    // 跳转到商品详情
    toProductDetail(id, item) {
      let data = {
        shopId: id,
        productId: item.productId,
        skuId: item.skuId
      };
      this.$router.push({
        path: "/productDetail",
        query: {
          proData: JSON.stringify(data)
        }
      });
    },
    // 复制文字
    copyText(text) {
      clipboard.writeText(text);
      this.$message.success("复制成功!");
    },
    // 获取用户信息
    getUserInfo() {
      let self = this;
      let params = {
        url: api.getUserInfo,
        method: "post",
        data: {
          buyerUserId: this.userInfo.buyerUserId,
        },
      };
      self.sendReq(params, (res) => {

        if (res.code === "200") {
          self.setUserInfo(res.data);
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    // 倒计时
    countDown() {
      clearInterval(this.setTime);
      this.setTime1 = setInterval(() => {
        if (this.groupData.time >= 1000) {
          this.groupData.time -= 1000;
        } else {
          this.groupData.time = 0;
          clearInterval(this.setTime);
          window.location.reload();
        }
      }, 1000);
    },
    // 时间戳转分秒
    toHHmmss(date) {
      var timer = "";
      var minutes = parseInt((date % (1000 * 60 * 60)) / (1000 * 60));
      // var seconds = (date % (1000 * 60)) / 1000
      timer = (minutes < 10 ? "0" + minutes : minutes) + "分";
      return timer;
    },
    // 获取订单详情
    getOrderDetail() {
      const rLoading = this.openLoading();
      let self = this;
      let params = {
        url: self.parentId
          ? api.getOrderDetail +
          "?parentId=" +
          self.parentId +
          "&noticeId=" +
          self.noticeId
          : api.getOrderDetail +
          "?orderId=" +
          self.orderId +
          "&noticeId=" +
          self.noticeId,
        method: "GET",
        data: {}
      };
      self.sendReq(params, res => {
        if (res.code === "200") {
          self.orderDetail = res.data;
          console.log(self.orderDetail)
          self.orderDetail.payCount = 0
          for (let j = 0; j < self.orderDetail.billList.length; j++) {
            if (self.orderDetail.billList[j].billStatus == 1) {
              self.orderDetail.payCount++
            }
          }
          console.log(self.orderDetail)
          self.groupData = res.data.collageDetail;
          self.endTime = res.data.time;
          self.getDilevery();
          self.formatStatus(res.data);
          if (self.groupData.time) {
            self.endTime1 = self.groupData.time;
          }
          if (
            self.groupData.time >= 1000 &&
            res.data.state === 6 &&
            self.groupData.state === 0
          ) {
            self.countDown();
          }
          self.getUserInfo();
          rLoading.close();
        } else {
          self.$message({
            message: res.message,
            type: "warning"
          });
        }
      });
    },
    formatStatus(detail) {
      // detail.state = 5
      if (detail.state != 5) {
        if (detail.state == 1) {
          //已下单
          this.statusArr[0].intro = `创建时间: ${detail.createTime}`;
          this.statusArr2[0].intro = `创建时间: ${detail.createTime}`;
        } else if (detail.state == 2) {
          //待付款
          this.statusArr[0].title = `商家已确认`;
          this.statusArr[0].intro = `确认时间: ${detail.updateTime}`;
          this.statusArr2[0].title = `商家已确认`;
          this.statusArr2[0].intro = `确认时间: ${detail.updateTime}`;
        } else if (detail.state == 3) {
          //待核销
          this.statusArr[0].title = `商家已确认`;
          this.statusArr[0].intro = `确认时间: ${detail.updateTime}`;
          this.statusArr[1].title = `买家已付款`;
          this.statusArr[1].intro = `付款时间: ${detail.paymentTime}`;
        } else if (detail.state == 4) {
          //已完成
          this.statusArr[0].title = `商家已确认`;
          this.statusArr[0].intro = `确认时间: ${detail.updateTime}`;
          this.statusArr[1].title = `买家已付款`;
          this.statusArr[1].intro = `付款时间: ${detail.paymentTime}`;
          this.statusArr[2].title = `卖家已核销`;
          this.statusArr[2].intro = `核销时间: ${detail.updateTime}`;
          this.statusArr[3].intro = `完成时间: ${detail.updateTime}`;

          this.statusArr2[0].title = `商家已确认`;
          this.statusArr2[0].intro = `确认时间: ${detail.updateTime}`;
          this.statusArr2[1].title = `买家已付款`;
          this.statusArr2[1].intro = `付款时间: ${detail.paymentTime}`;
          this.statusArr2[3].intro = `完成时间: ${detail.updateTime}`;
        }
      } else {
        this.statusArr_close[0].intro = `创建时间: ${detail.createTime}`;
        this.statusArr_close[1].intro = `关闭时间: ${detail.updateTime}`;
      }
    },
    // 查询物流信息
    getDilevery() {
      let self = this;
      let params = {
        url:
          api.getDilevery +
          `?express=${self.orderDetail.express}` +
          `&deliverFormid=${self.orderDetail.deliverFormid}`,
        method: "GET",
        data: {}
      };
      self.sendReq(params, res => {
        if (res.code === "200") {
          // console.log(res)
          self.dilevery = res.data;
        } else {
          self.$message({
            message: res.message,
            type: "warning"
          });
        }
      });
    },
    // 取消订单
    cancelOrder() {
      let self = this;
      let params = {
        url: api.cancelOrder,
        method: "PUT",
        data: {
          orderId: self.orderDetail.orderId
        }
      };
      self.sendReq(params, res => {
        // console.log(res)
        if (res.code === "200") {
          self.closeOrderDialog = false;
          self.getOrderDetail();
        } else {
          self.$message({
            message: res.message,
            type: "warning"
          });
        }
      });
    },
    // 去付款
    // pay () {
    //     let self = this
    //     let params = {
    //         url: api.pay,
    //         method: 'PUT',
    //         data: {
    //           orderId: self.orderDetail.orderId,
    //           type: 2,
    //           money: self.orderDetail.price
    //         }
    //     }
    //     self.sendReq(params, (res) => {
    //       if (res.code === '200') {
    //          self.getOrderDetail()
    //       } else {
    //         self.$message({
    //             message: res.message,
    //             type: 'warning'
    //         })
    //       }
    //     })
    // },
    handleRemove(file) {
      // console.log(file)
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      // console.log(file)
    },
    // 取消订单
    closeOrder() {
      this.closeOrderDialog = true;
    },
    // 邀请好友
    inviteFriends() {
      let params = {
        url:
          api.getShare +
          `?collageId=${this.orderDetail.collageId}&orderId=${this.orderDetail.orderId
          }&productId=${this.orderDetail.skus[0].productId}&skuId=${this.orderDetail.skus[0].skuId
          }&type=0`,
        method: "GET"
      };
      this.sendReq(params, res => {
        if (res.code === "200") {
          this.share = res.data;
        }
      });
      this.inviteDialog = true;
    },
    closeOrderBtn() {
      this.closeOrderDialog = false;
    },
    inviteDialogClose() {
      this.inviteDialog = false;
    },
    // 再次开团
    again() {
      let data = {
        shopId: this.orderDetail.shopId,
        productId: this.orderDetail.skus[0].productId,
        skuId: this.orderDetail.skus[0].skuId
      };
      this.$router.push({
        path: "/productDetail",
        query: {
          proData: JSON.stringify(data)
        }
      });
    },
    checkPayType() {
      let payType = this.orderDetail.paymentMode;
      let dialogPrice = this.orderDetail.price
      let self = this;
      switch (Number(payType)) {
        case 1: //微信
        case 2: //支付宝
          this.getUrl();
          break;
        case 3: //转账汇款
          this.showTeachDialog = true;
          break;
        case 4:

          this.$confirm({
            title: "是否确认付款",
            content: (h) => <div>待付款金额: <span style="color:#ff4747;font-size:16px;">¥{dialogPrice}</span></div>,
            onOk() {
              let params = {
                url: api.getPayCode,
                method: "GET",
                payload: {
                  orderId: self.orderDetail.orderId
                }
              };
              self.sendReq(params, res => {
                if (res.code === "200") {
                  self.$message.success("支付成功!");
                  self.getOrderDetail()
                } else {
                  self.$message({
                    message: res.message,
                    type: "error"
                  });
                }
              });
            },
            onCancel() { },
            class: "test"
          });
          break;
        case 6:
          let self = this;
          this.$confirm({
            title: "是否确认付款",
            content: (h) => <div>待付款金额: <span style="color:#ff4747;font-size:16px;">¥{dialogPrice}</span></div>,
            onOk() {
              let params = {
                url: api.getPayCode,
                method: "GET",
                payload: {
                  orderId: self.orderDetail.orderId
                }
              };
              self.sendReq(params, res => {
                if (res.data && res.data.url) {
                  self.$message({
                    message: '订单提交成功，即将跳转支付...',
                    type: "success",
                  });
                  setTimeout(() => {
                    var a = document.createElement('a');
                    a.setAttribute('href', res.data.url);
                    a.setAttribute('target', '_blank');
                    a.setAttribute('id', "toPay");
                    // 防止反复添加
                    if (!document.getElementById("toPay")) document.body.appendChild(a);
                    a.click();
                  }, 2000);
                }
                // if (res.code === "200") {
                //   self.$message.success("支付成功!");
                //   self.getOrderDetail()
                // }
                else {
                  self.$message({
                    message: res.message,
                    type: "error"
                  });
                }
              });
            },
            onCancel() { },
            class: "test"
          });
          break;
      }
    },
    // 付款
    getUrl() {
      let self = this;
      let params = {
        url: api.getPayCode,
        method: "GET",
        payload: {
          orderId: self.orderDetail.orderId
        }
      };
      self.sendReq(params, res => {
        if (res.code === "200") {
          self.payInfo = res.data;
          self.weChatDialog = true;
          self.chatTimer = setInterval(() => {
            self.checkPay(res.data);
          }, 2000);
        } else {
          self.$message({
            message: res.message,
            type: "error"
          });
        }
      });
    },
    // 取消支付
    handleClose() {
      // this.$confirm('确认取消支付？')
      //   .then(_ => {
      //     clearInterval(this.chatTimer)
      //     this.weChatDialog = false
      //   })
      //   .catch(_ => {})
      let _this = this;
      this.$confirm({
        okText: "确定",
        cancelText: "取消",
        title: "取消支付",
        content: "确认取消支付？",
        onOk() {
          clearInterval(_this.chatTimer);
          _this.weChatDialog = false;
        },
        onCancel() { }
      });
    },
    checkPay(paramsData) {
      setTimeout(() => {
        let self = this;
        let params = {
          url:
            api.checkPay +
            `?collageId=${paramsData.collageId}&money=${paramsData.money
            }&orderId=${paramsData.orderId}&type=2`,
          method: "GET"
        };
        self.sendReq(params, res => {
          if (res.code === "200") {
            if (res.data.code === "SUCCESS") {
              self.$message({
                message: "支付成功！",
                type: "success"
              });
              clearInterval(self.chatTimer);
              self.weChatDialog = false;
              self.getOrderDetail();
            }
          } else {
            clearInterval(self.chatTimer);
            self.$message({
              message: res.message,
              type: "error"
            });
            self.weChatDialog = false;
          }
        });
      }, 0);
    }
  }
};
</script>
<style lang="scss">
.userCenter .userCenterInfo {
  // background-color: transparent !important;
}

.price {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

.main {
  background: #f5f5f5;
}

.orderDetail {
  .ant-tabs-nav-container {
    height: 57px !important;
  }

  .ant-tabs-nav-wrap {
    background: #f6f6f6;
  }

  .card-container {
    .ant-tabs-tab {
      border: 3px solid transparent !important;
      border-radius: 0 !important;
      background: transparent !important;
      height: 57px !important;
      font-size: 18px !important;
      line-height: 55px !important;
    }

    .ant-tabs-tab-active {
      height: 57px !important;
      color: #ff7800;
      background: #fff !important;
      border: 3px solid #ff7800 !important;
      border-bottom: 1px solid #fff !important;
      z-index: 12;
    }

    .ant-tabs-nav-container:after {
      content: "";
      height: 0px;
      width: 100%;
      position: absolute;
      bottom: 0;
      border-bottom: 3px solid #ff7800 !important;
      z-index: 10;
      // background-color: #ff7800;
      left: 0;
    }

    .order-detail-base {
      display: flex;
      align-items: stretch;

      &>div {
        width: 33.3% !important;
        padding-left: 30px;
        padding-top: 30px;
        margin-bottom: 17px;
        border-right: 1px dotted #e5e5e5;

        &>p {
          font-size: 14px;
          color: #606266;
          margin-bottom: 9px;
        }

        &>p:first-child {
          display: flex;
          align-items: center;

          i {
            color: #f77b0b;
            margin-right: 5px;
            font-size: 21px;
          }

          font-size: 16px;
          font-weight: bold;
          color: #333333;
          margin-bottom: 12px;
        }

        &>p:not(:first-child) {
          margin-left: 25px;
        }
      }

      // &>div:first-child{
      //     border-right: 1px dotted #e5e5e5;
      // }
    }
  }
}

.offlinePayBox {
  .offlinePayBox-title {
    display: flex;
    align-items: flex-end;

    &>span {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      margin-right: 19px;
    }

    &>div {
      font-size: 14px;
      font-weight: bold;
      color: #f77b0b;
    }
  }

  .offlinePayBox-process-bar {
    display: flex;
    margin-top: 12px;
    height: 38px;
    align-items: center;

    &>span {
      width: 15px;
      margin-right: 10px;
      font-size: 22px;
      font-weight: bold;
      color: #f77b0b;
      display: flex;
      align-items: flex-start;
    }

    &>div {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      &>span:nth-child(1) {
        font-size: 16px;
        font-weight: bold;
        color: #333333;
      }
    }
  }

  .offlinePayBox-process-bar-small {
    padding-left: 25px;
    font-size: 12px;
    color: #606266;
  }

  .offlinePayBox-main-box {
    width: 635px;
    background: rgba(247, 123, 11, 0.1);
    margin: 13px 24px;

    .offlinePayBox-main-box-title {
      height: 37px;
      font-size: 14px;
      font-weight: bold;
      color: #f77b0b;
      border-bottom: 2px solid #f7790b57;
      display: flex;
      align-items: center;
      padding-left: 38px;
    }

    &>div:not(first-child) {
      height: 40px;
      display: flex;
      align-items: center;

      &>span:nth-child(1) {
        width: 90px;
        font-size: 12px;
        color: #606266;
        text-align: right;
        margin-right: 26px;
      }

      &>span:nth-child(2) {
        font-size: 16px;
        color: #333333;
      }

      &>span:nth-child(3) {
        font-size: 12px;
        color: #606266;
        margin-left: auto;
        margin-right: 20px;
        cursor: pointer;
      }
    }

    &>div:last-child {
      &>span:nth-child(2) {
        font-size: 16px;
        font-weight: bold;
        color: #ff4747;
      }
    }
  }

  .offlinePayBox-small-info {
    margin-top: 32px;
    padding: 0 22px;

    .offlinePayBox-small-info-title {
      font-size: 14px;
      font-weight: bold;
      color: #333333;

      &>span:first-child {
        color: #ff4747;
        // margin-right: 5px;
      }
    }

    .offlinePayBox-small-info-bar {
      display: flex;
      align-items: center;
      position: relative;
      height: 28px;
      font-size: 12px;
      font-weight: 400;
      color: #606266;

      span {
        color: #ff4747;
      }
    }

    .offlinePayBox-small-info-bar:before {
      content: "";
      display: inline-block;
      width: 5px;
      height: 5px;
      background: #606266;
      border-radius: 50%;
      position: relative;
      margin-right: 5px;
      // left: -5px;
    }

    img {
      width: 826px;
    }
  }
}
</style>
<style lang="scss" scoped>
.orderDetail {
  width: 100%;

  // .ant-btn-background-ghost {
  //     border: 1px solid;
  // }
  .head {
    width: 1612px;
    margin: 13px auto;
    padding: 0 27px 0 0px;
    // width: 100%;
    // height: 50px;
    // line-height: 50px;
    font-size: 16px;
    display: flex;
    align-items: center;

    .arrow {
      background-image: url("../../../static/image/xiangyou@2x.png");
      width: 5px;
      height: 10px;
      margin-right: 10px;
    }
  }

  .banxin {
    background: #ffffff;
    width: 100%;
    margin: 0px auto 27px auto;
    padding: 0 27px 27px 27px;

    .status_arrow {
      height: 33px;
      display: flex;
      align-items: center;

      i {
        color: #dcdfe6;
        font-size: 24px;
      }
    }

    .statusBar {
      display: flex;
      height: 146px;
      align-items: center;
      padding-bottom: 16px;
      justify-content: space-around;

      .status_box {
        height: 33px;

        div:first-child {
          display: flex;
          align-items: center;
          font-size: 19px;
          font-weight: 400;
          color: #999999;
          height: 33px;

          span:first-child {
            display: flex;
            width: 29px;
            height: 29px;
            border: 1px solid #999999;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            margin-right: 14px;
          }
        }

        &>span {
          display: inline-block;
          font-size: 12px;
          font-weight: 400;
          color: #b9b9b9;
          margin-top: 9px;
        }
      }

      .active_status {
        div:first-child {
          color: #999999;

          span:first-child {
            background: #f77b0b;
            border: 1px solid #f77b0b;
            color: #ffffff;
          }

          span {
            color: #f77b0b;
          }
        }

        &>span {
          color: #ff983e;
        }

        position: relative;

        .active_status_after {
          display: inline-block;
          width: 0;
          height: 0;
          border: 16px solid transparent;
          border-bottom-color: #ff8313;
          position: absolute;
          top: 65px;
          left: 50%;
          margin-left: -16px;
        }
      }
    }

    .active_status {
      &>i {
        color: #f77b0b;
      }
    }

    .teach-user {
      height: 176px;
      margin-bottom: 30px;
      background: #f7790b1a;

      .order-detail-bar {
        display: flex;
        align-items: center;
        padding: 14px;
        border-bottom: 1px solid #f7790b63;

        &>span:nth-child(1) {
          // width: 81px;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 33px;
          background: #477ce5;
          color: #ffffff;
          padding: 13px;
          font-size: 14px;
        }

        &>span:nth-child(2) {
          font-size: 14px;
          color: #333333;
          margin-left: 11px;
        }

        &>span:nth-child(3) {
          font-size: 14px;
          color: #f77b0b;
          margin-left: 11px;
        }

        &>i:nth-child(4) {
          color: #f77b0b;
          margin-left: 60px;
          font-size: 16px;
          margin-right: 7px;
        }

        &>div:nth-child(5) {
          span {
            color: #333333;
            font-size: 14px;
          }

          .time-nums {
            color: #f77b0b;
            // margin-right: 5px;
          }
        }
      }

      .order-detail-content {
        height: 113px;
        padding: 5px 33px 0 33px;

        // display: flex;
        // flex-direction: column;
        // justify-content: space-around;
        &>div {
          height: 33.3%;
          display: flex;
          align-items: center;

          button {
            margin: 0 9px;
          }

          button:nth-child(2) {
            margin-left: 15px;
          }
        }
      }
    }

    .product-container {
      border-left: 1px solid #e5e5e5;
      border-right: 1px solid #e5e5e5;

      .productInfo {
        width: 100%;

        .top {
          height: 46px;
          width: 100%;
          background: #f3f3f3;
          border: 1px solid #e5e5e5;
          display: flex;
          align-items: center;
          text-align: center;

          span {
            flex: 1;
            font-size: 14px;
            color: #333333;
          }

          .big {
            flex: 2;
          }
        }

        .bottom {
          cursor: pointer;
          width: 100%;
          padding: 20px 0;
          box-sizing: border-box;
          text-align: center;
          display: flex;
          border-bottom: 1px solid #e5e5e5;

          div {
            flex: 1;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;

            p {
              font-size: 14px;
              line-height: 20px;
            }
          }

          .big {
            text-align: left;
            flex: 2;
            display: flex;
            box-sizing: border-box;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 80px;
              height: 80px;
              margin: 0 20px;
            }

            p {
              width: 50%;
            }
          }
        }
      }
    }

    .settlement-container {
      .settlement {
        width: 100%;
        display: flex;
        padding: 25px;
        box-sizing: border-box;
        justify-content: flex-end;

        .box {
          display: flex;

          .left {
            text-align: right;

            p {
              width: 260px;
              display: flex;
              justify-content: space-between;
              font-size: 14px;
              color: #333333;
              // line-height: 30px;
              align-items: center;

              span {
                color: #ff4747 !important;
                font-size: 22px;
              }
            }

            .right {
              text-align: right;
              // margin-left: 40px;
              color: #ff4747 !important;
              font-size: 22px;
            }
          }
        }
      }
    }

    .remark-box {
      background-color: rgba(247, 247, 247, 1);
      min-height: 100px;
      padding: 24px;
    }

    .status {
      width: 100%;
      height: 325px;
      border: 1px solid #e5e5e5;
      box-sizing: border-box;
      padding: 15px;
      display: flex;
      margin-bottom: 20px;

      .left {
        flex: 1;
        border-right: 1px solid #e5e5e5;
        display: flex;
        align-items: center;
        flex-direction: column;

        .cancel {
          width: 100px;
          margin-left: 0;
        }

        .invite {
          width: 100px;
          border: 1px solid #ff7800;
          color: #ff7800;
        }

        .pay {
          width: 100px;
          border-color: #ff7800;
          color: #ff7800;
          margin-left: 0;
        }

        .pay:hover {
          background-color: rgba($color: #ff7800, $alpha: 0.3);
        }

        .box {
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .groupShopping {
          .groupShopTit {
            font-size: 24px;
            font-weight: bold;
            color: $mainColor;
            margin-bottom: 18px;
          }

          span {
            width: 100px;
            height: 30px;
            line-height: 30px;
            border: 1px solid #ff7800;
            border-radius: 4px;
            color: $mainColor;
            font-size: 14px;
            display: block;
            text-align: center;
            margin-bottom: 12px;
            cursor: pointer;
          }

          .closeOrder {
            font-size: 14px;
            color: #999999;
            border: 1px solid #999999;
          }
        }
      }

      .right {
        flex: 3;
        padding: 20px;
        box-sizing: border-box;
      }
    }

    .logistics {
      padding: 25px;
      width: 100%;
      box-sizing: border-box;
      margin-bottom: 20px;
      border: 1px solid #e5e5e5;

      .content {
        display: flex;

        .left {
          padding: 20px 0;
          flex: 2;
          display: flex;
          align-items: center;
          box-sizing: border-box;
          border-right: 2px solid #e5e5e5;

          img {
            width: 200px;
            height: 200px;
            margin-right: 40px;
          }

          div {
            p {
              font-size: 14px;
              color: #666666;
              margin-bottom: 20px;
            }
          }
        }

        .right {
          flex: 3;
          padding: 20px;
          box-sizing: border-box;
          display: flex;

          .dilevery {
            height: 280px;
            width: 600px;
            overflow-x: auto;
            padding: 20px;
            box-sizing: border-box;
            // div{
            //     padding-left: 25px;
            //     margin-bottom: 25px;
            //     position: relative;
            //     box-sizing: border-box;
            //     white-space: nowrap;
            //     .dot{
            //         // display: inline-block;
            //         width: 6px;
            //         height: 6px;
            //         border-radius: 3px;
            //         background-color: #D9D9D9;
            //         margin-right: 10px;
            //         position: absolute;
            //         left: 0;
            //         top: 50%;
            //         transform: translate(50%,0);
            //         .line{
            //             position: absolute;
            //             left: 50%;
            //             top: 12px;
            //             transform: translate(-50%,0);
            //             width: 2px;
            //             height: 25px;
            //             background-color: #F1F1F1;
            //         }
            //     }
            // .line{
            //     width: 100%;
            //     border-left: 2px solid #F1F1F1;
            //     height: 25px;
            //     margin-left: -21px;
            // }
            // }
            // div:last-child{
            //     margin-bottom: 0;
            //     .line{
            //         display: none;
            //     }
            // }
            // .active{
            //     .dot{
            //         background-color: #FF7800;
            //     }
            // }
          }
        }
      }
    }

    .desc {
      width: 100%;
      border: 1px solid #e5e5e5;
      margin-bottom: 140px;

      .receivingInfo,
      .storeInfo,
      .orderInfo {
        padding: 25px;
        border-bottom: 1px solid #e5e5e5;

        .title {
          font-size: 16px;
          margin-bottom: 25px;
        }

        .info {
          display: flex;
          margin-left: 75px;
          flex-wrap: wrap;

          p {
            line-height: 30px;
            width: 50%;
            font-size: 14px;
          }
        }
      }

      .orderInfo,
      .receivingInfo {
        .info {
          p {
            width: 33.33%;
          }
        }
      }

      .productInfo {
        width: 100%;

        .top {
          height: 40px;
          width: 100%;
          background-color: #ededed;
          display: flex;
          align-items: center;
          text-align: center;

          span {
            flex: 1;
            font-size: 12px;
          }

          .big {
            flex: 2;
          }
        }

        .bottom {
          width: 100%;
          padding: 20px 0;
          box-sizing: border-box;
          text-align: center;
          display: flex;
          border-bottom: 1px solid #e5e5e5;

          div {
            flex: 1;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;

            p {
              font-size: 14px;
              line-height: 20px;
            }
          }

          .big {
            text-align: left;
            flex: 2;
            display: flex;
            box-sizing: border-box;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 80px;
              height: 80px;
              margin: 0 20px;
            }

            p {
              width: 50%;
            }
          }
        }
      }

      .settlement {
        width: 100%;
        display: flex;
        padding: 25px;
        box-sizing: border-box;
        justify-content: flex-end;

        .box {
          display: flex;

          .left {
            text-align: right;

            p {
              width: 250px;
              display: flex;
              justify-content: space-between;
              font-size: 20px;
              color: #666666;
              line-height: 30px;
            }

            .right {
              text-align: right;
              margin-left: 40px;
            }
          }
        }
      }
    }
  }

  .emptyBox {
    text-align: center;
    margin: 96px 0 115px 0;
    color: #999;
  }

  .groupBuying {
    border: 1px solid #e5e5e5;
    height: 325px;
    padding: 20px;
    margin-bottom: 20px;

    .groupBuyTit {
      font-size: 16px;
      color: #333333;
      font-weight: bold;
    }

    .groupBuyBox {
      text-align: center;
      margin-top: 30px;

      .result {
        font-size: 18px;
        margin-bottom: 20px;
      }

      .result0 {
        color: #ec4b42;
      }

      p {
        font-size: 14px;
        color: #333333;
        margin-bottom: 20px;

        span {
          color: #ff7800;
          font-size: 14px;
          font-weight: normal;
        }
      }

      .surplusTime {
        margin-bottom: 30px;
        font-size: 16px;
        color: #666666;
        display: flex;
        justify-content: center;
        align-items: center;

        .day {
          margin-left: 10px;
        }

        .time {
          color: #ff7800;
        }

        span {
          border: 1px solid #e5e5e5;
          border-radius: 2px;
          display: block;
          width: 24px;
          height: 24px;
          text-align: center;
          line-height: 20px;
          margin: 0 8px;
        }
      }

      .userList {
        display: flex;
        justify-content: center;
        align-items: center;

        span {
          display: block;
          width: 76px;
          height: 76px;
          position: relative;
          margin: 0 13px;
          border-radius: 50%;
          box-sizing: border-box;

          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }

          i {
            position: absolute;
            left: 8px;
            bottom: -10px;
            width: 60px;
            height: 24px;
            background: $mainColor;
            border-radius: 12px;
            font-style: normal;
            text-align: center;
            line-height: 24px;
            color: #ffffff;
            font-size: 14px;
          }
        }

        .noPeople {
          border: 1px dashed #e5e5e5;
          color: #dbdbdb;
          font-size: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        span:first-child {
          border: 1px solid $mainColor;
        }
      }
    }
  }

  .inviteDialog {
    text-align: center;

    .inviteTit {
      font-size: 22px;
      color: #444444;
    }

    .imgCode {
      width: 200px;
      height: 200px;
      margin: 0 auto;

      img {
        width: 100%;
        height: 100%;
      }
    }

    p {
      margin: 25px 0;
    }

    .linkBox {
      display: flex;
      justify-content: center;

      .linkAddress {
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        display: block;
        width: 220px;
        text-align: left;
        border: 1px solid #e5e5e5;
      }

      .copyBtn {
        width: 100px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background: #ffffff;
        border: 1px solid $mainColor;
        color: $mainColor;
        margin-left: 20px;
        cursor: pointer;
      }
    }
  }

  .weChatBox {
    // display: flex;
    text-align: center;

    img {
      width: 100%;
    }

    .qCode {
      padding: 10px 20px;
      width: 100%;
      text-align: center;

      img {
        width: 60%;
      }
    }

    .weChatInfo {
      width: 50%;
    }
  }

  .weChat {
    >>>.el-dialog__body {
      background: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/orderDetail_B2B_serv/index.vue